import i18n, { validLanguages } from 'common/services/translations/translations';

export const i18nPostureNamespace = 'posture';

export const initializeI18nPosture = async () => {
    return Promise.all(
        validLanguages.map(async (language) => {
            try {
                const contents = await require(`./languages/${language}/translation.json`);
                i18n.addResourceBundle(language, `${i18nPostureNamespace}`, contents);
            } catch {
                //Nothing to do with missing translation files
            }
        }),
    );
};
